import { render, staticRenderFns } from "./FTPRestoreModal.vue?vue&type=template&id=af126700&"
import script from "./FTPRestoreModal.vue?vue&type=script&lang=js&"
export * from "./FTPRestoreModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports